import { render, staticRenderFns } from "./WsContentRemark.vue?vue&type=template&id=5ce6b2d2&"
import script from "./WsContentRemark.vue?vue&type=script&lang=js&"
export * from "./WsContentRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports